/**
 * @desc 分页
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<
  defs.tms.IPage<defs.tms.LogisticsQuotationSurchargeFormulaResponseDto>
>;
export function request(
  params: API.tms.logisticsQuotationSurchargeFormula.page.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotationSurchargeFormula/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
